export default function minArrayObjectElement<T, K extends keyof T>(
  array: T[] | null | undefined,
  element: K,
): T | undefined {
  if (!array?.length) return undefined;
  return array.reduce((min, curr) => (curr[element] < min[element] ? curr : min));
}
